import React from 'react'
import TestSpeakableText from './TestSpeakableText'
import QuestionSpeakableText from './QuestionSpeakableText'

const SpeakableText = ({ isTestSettings, ...props }) => {
  if (isTestSettings) {
    return <TestSpeakableText {...props} />
  }
  return <QuestionSpeakableText {...props} />
}

export default SpeakableText
